import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { LinkText, Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import CollapsableCard from "../../../../common/CollapsableCard";
import NumberedList from "../../../../common/NumberedList";
import StreamlabsSetupImage from "../../../../../../assets/images/courses/live-session/streamlabs-setup.png";

export const LiveSetupStreamingToolInstallCard = () => {
  const intl = useIntl();
  return (
    <CollapsableCard
      headlineNumber={1}
      headlineText={intl.formatMessage({ id: "live_sessions.streamlabs_setup.step_1.title" })}
    >
      <Flex flexDirection="column">
        <Text size="tiny" textAlign="left" as="p" marginTop={6}>
          <FormattedMessage id="live_sessions.streamlabs_setup.step_1.streamlabs_explanation" />
        </Text>
        <Text size="tiny" textAlign="left" as="p" marginTop={5}>
          <FormattedMessage
            id="live_sessions.streamlabs_setup.step_1.streamlabs_download"
            values={{
              streamlabs_link: (
                <LinkText underline href="https://streamlabs.com" target="_blank" rel="noreferrer">
                  Streamlabs OBS
                </LinkText>
              ),
            }}
            ignoreTag
          />
        </Text>
        <NumberedList
          marginTop={6}
          items={[
            {
              headline: intl.formatMessage({
                id: "live_sessions.streamlabs_setup.step_1.allow_access",
              }),
            },
            {
              headline: intl.formatMessage({
                id: "live_sessions.streamlabs_setup.step_1.skip_connect",
              }),
            },
            {
              headline: intl.formatMessage({
                id: "live_sessions.streamlabs_setup.step_1.welcome_screen",
              }),
            },
            {
              headline: intl.formatMessage({
                id: "live_sessions.streamlabs_setup.step_1.configure_inputs",
              }),
            },
            {
              headline: intl.formatMessage({
                id: "live_sessions.streamlabs_setup.step_1.skip_theme",
              }),
              children: (
                <img
                  src={StreamlabsSetupImage}
                  style={{ marginLeft: "-16px", marginTop: "8px", maxWidth: "100%" }}
                  alt=""
                />
              ),
            },
            {
              headline: intl.formatMessage({ id: "live_sessions.streamlabs_setup.step_1.sources" }),
              children: (
                <ul
                  style={{
                    listStyle: "inside",
                    textIndent: "-20px",
                    marginLeft: "20px",
                    marginTop: "24px",
                  }}
                >
                  <Text size="tiny" as="li" textAlign="left">
                    <FormattedMessage id="live_sessions.streamlabs_setup.step_1.video_capture" />
                  </Text>
                  <Text size="tiny" as="li" textAlign="left">
                    <FormattedMessage id="live_sessions.streamlabs_setup.step_1.add_source" />
                  </Text>
                  <Text size="tiny" as="li" textAlign="left">
                    <FormattedMessage id="live_sessions.streamlabs_setup.step_1.click_done" />
                  </Text>
                </ul>
              ),
            },
          ]}
        />
      </Flex>
    </CollapsableCard>
  );
};

export default LiveSetupStreamingToolInstallCard;
